import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Home } from "lucide-react";

export default function ConfirmCitizen() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, email: "", error: "" });

  useEffect(() => {
    api.get(`/citizens/confirm/${token}`).then(({ data }) => {
      setState({ loading: false, ok: true, email: data.email, error: "" });
    }).catch((err) => {
      setState({ loading: false, ok: false, email: "", error: err.response?.data?.detail || "Enllaç invàlid" });
    });
  }, [token]);

  return (
    <PublicLayout>
      <div className="max-w-md mx-auto px-6 py-20">
        <Card className="rounded-3xl border-2 shadow-xl">
          <CardContent className="p-8 text-center">
            {state.loading ? (
              <div className="text-muted-foreground py-6" data-testid="confirm-loading">Verificant…</div>
            ) : state.ok ? (
              <div data-testid="confirm-ok">
                <div className="w-16 h-16 mx-auto rounded-2xl bg-emerald-100 text-emerald-600 flex items-center justify-center mb-4">
                  <CheckCircle2 className="w-8 h-8" aria-hidden="true" />
                </div>
                <h1 className="font-heading font-bold text-2xl">Subscripció confirmada!</h1>
                <p className="text-muted-foreground mt-3">Ja rebràs les novetats a <strong>{state.email}</strong>.</p>
              </div>
            ) : (
              <div data-testid="confirm-error">
                <div className="w-16 h-16 mx-auto rounded-2xl bg-destructive/10 text-destructive flex items-center justify-center mb-4">
                  <XCircle className="w-8 h-8" aria-hidden="true" />
                </div>
                <h1 className="font-heading font-bold text-2xl">Enllaç no vàlid</h1>
                <p className="text-muted-foreground mt-3">{state.error}</p>
              </div>
            )}
            <Button asChild className="mt-6 rounded-full" data-testid="confirm-home-btn">
              <Link to="/"><Home className="w-4 h-4 mr-2" aria-hidden="true" /> Tornar a l'inici</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </PublicLayout>
  );
}
